import { jsx as _jsx } from "react/jsx-runtime";
import { Route, Routes } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import CommonLayout from '../layouts/common';
var RouteGenerator = function (_a) {
    var routes = _a.routes, LAYOUT = _a.layout;
    //console.log('Routes in RouteGenerator:', routes, LAYOUT);
    return (_jsx(Routes, { children: _jsx(Route, { element: LAYOUT ? _jsx(LAYOUT, {}) : _jsx(CommonLayout, {}), children: routes.map(function (_a, index) {
                var PATH = _a.PATH, COMPONENT = _a.COMPONENT, isProtected = _a.isProtected;
                return (_jsx(Route, { path: PATH, element: _jsx(ProtectedRoute, { component: COMPONENT, isProtected: isProtected }) }, index));
            }) }) }));
};
export default RouteGenerator;
